import { FC, ReactElement } from 'react'
import './index.css'
const CustomBanner: FC<{ bannerName: string }> = ({ children, bannerName }): ReactElement => {
  return <div className={`banner banner-onthehub custom-banner ${bannerName ? 'banner-' + bannerName : ''}`}>{children}</div>
}

export default CustomBanner
